import React, { useContext } from 'react';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { Employee } from '../../pages/arc/features/employment/employment-model';
import { ArcRoutes } from '../../pages/arc/constants/routes';
import { TcsmStates } from '../../root/tcsm-model';
import { headerIconStyles } from '../constants/theme/styles/components/header-icon-styles';
import { DemographicsContext } from '../models/demographics-model';
import { Institution } from '../models/institution-model';
import { Person } from '../models/person-model';


export function InstitutionNameClientNumber() {

	const app = useContext(DemographicsContext);
	const headerIconClasses = headerIconStyles();
	const clientNumberLabel = useSelector<TcsmStates, string>(state => state?.epiProps?.labelSettingState?.epiContent?.clientNumberLabel);
	const currentInstitution = useSelector<TcsmStates, Institution>(state => state?.institutionState?.currentInstitution);
	const person = useSelector<TcsmStates, Person>(state => state?.personalInfo[app].currentPerson);
	const currentEmployee = useSelector<TcsmStates, Employee>(state => state?.employmentState?.currentEmployee);
  const location = useLocation();

	if (!currentInstitution || person || currentEmployee || location.pathname.includes(ArcRoutes.GroupsLanding )) return null;

	return (

		<div>
			<div className={headerIconClasses.iconHeader}>
				{/*<ClericIndicator shieldIcon />*/}
				<h4>{currentInstitution?.organization_name}</h4>
			</div>
			<p>{`${clientNumberLabel}: ${currentInstitution?.org_client_nbr}`} </p>
		</div>
	);
}
